var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_METHODS_ENUM } from "../../httpService";
import { RESET_BOOK_DATA } from "../actions";
import { START_LOADING, LOADING_SUCCESSFUL, LOADING_FAILED } from "../actions/response.actions";
export var loaderReducer = function (state, _a) {
    var _b, _c, _d;
    if (state === void 0) { state = {}; }
    var type = _a.type, name = _a.name;
    var now = new Date().getTime();
    var currentState = state[name] || {};
    switch (type) {
        case START_LOADING:
            return __assign(__assign({}, state), (_b = {}, _b[name] = __assign(__assign({}, currentState), { loading_started_at: now }), _b));
        case LOADING_SUCCESSFUL:
            return __assign(__assign({}, state), (_c = {}, _c[name] = __assign(__assign({}, currentState), { loading_finished_at: now }), _c));
        case LOADING_FAILED:
            return __assign(__assign({}, state), (_d = {}, _d[name] = __assign(__assign({}, currentState), { loading_failed_at: now }), _d));
        case RESET_BOOK_DATA:
            state = __assign({}, state);
            delete state[API_METHODS_ENUM.GET_BOOK_ENTITIES];
            return state;
    }
    return state;
};
